import ModelDelete from "@/pages/modals/_delete";
import { useDeleteTransactionMutation } from "@/services/transaction.service";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

export default function Delete() {
    const {t} = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [deleteTransaction, {isSuccess}] = useDeleteTransactionMutation()

    const onAccept = () => {
        deleteTransaction(location.state?.id || "")
    }

    useEffect(() => {
        if (isSuccess) {
            navigate(location, {state: {reload: true}})
        }
    }, [isSuccess])
    
    return <ModelDelete title={t("modal.delete_transaction")} content={t("modal.delete_transaction_content")} onAccept={onAccept} />
}
